import React, { forwardRef } from 'react';
import { i18n } from '../../../../language';
import Base from './Base';
import RoleEdit from './RoleEdit';
// allData => [] => {} =>
const WardTable = forwardRef(({ allData, editClick, nextPageCall, pageSize, hideIndex, setHideIndex }, ref) => {
  const tableHeads = [
    { text: i18n.t('SETTING_WARD_NAME'), value: 'wardName' },
    { text: i18n.t('SETTING_HOSPITAL'), value: 'hospitalName' },
    { text: i18n.t('SETTING_LAST_UPDATE'), value: 'lastUpdate', type: 'date' },
  ];
  const aligns = ['left', 'left', 'left'];
  const props = {
    tableHeads,
    aligns,
    allData,
    editClick,
    nextPageCall,
    pageSize,
    hideIndex,
    setHideIndex,
    ref,
  };
  return <Base {...props} />;
});

// allData => [] => {} =>
const RoleTable = ({ allData, editClick }) => {
  const tableHeads = [
    { text: i18n.t('SETTING_ROLE_NAME'), value: 'roleName' },
    { text: i18n.t('SETTING_LAST_UPDATE'), value: 'lastUpdate', type: 'date' },
  ];
  const aligns = ['left', 'left'];
  const props = {
    tableHeads,
    aligns,
    allData,
    editClick,
  };
  return <Base {...props} />;
};

// allData => [] => {} =>
const UserTable = forwardRef(
  ({ allData, editClick, nextPageCall, pageSize, setHideIndex, hideIndex, editDisabledFunc }, ref) => {
    const tableHeads = [
      { text: i18n.t('SETTING_CORP_ID'), value: 'corpId' },
      { text: i18n.t('SETTING_STAFF_NAME'), value: 'staffName' },
      { text: i18n.t('SETTING_HOSPITAL'), value: 'hospName' },
      { text: i18n.t('SETTING_WARD'), value: 'wardName' },
      { text: i18n.t('SETTING_ROLE'), value: 'roleName' },
      { text: i18n.t('SETTING_STATUS'), value: 'status', type: 'userStatus' },
      { text: i18n.t('SETTING_METHOD'), value: 'type', type: 'type' },
      { text: i18n.t('SETTING_LAST_UPDATE'), value: 'lastUpdate', type: 'date' },
      { text: i18n.t('SETTING_BY_PASS_HA_CHAT'), value: 'byPassHaChat', type: 'flag' },
    ];
    const aligns = ['left', 'left', 'left', 'left', 'left', 'left', 'left'];
    const props = {
      tableHeads,
      aligns,
      allData,
      editClick,
      nextPageCall,
      pageSize,
      setHideIndex,
      hideIndex,
      ref,
      editDisabledFunc,
    };
    return <Base {...props} />;
  }
);

const RoleEditTable = ({ allData, updateInputValue, className }) => {
  const aligns = ['left', 'left'];
  const props = {
    aligns,
    allData,
    updateInputValue,
    className,
  };
  return <RoleEdit {...props} />;
};

const CategoryEditTable = ({ allData, editClick, deleteClick, deleteDisabledFunc }) => {
  const tableHeads = [
    { text: i18n.t('DUTYASSIGN_CREATE_CHATROOM_CATEGORY_TITLE'), value: 'category' },
    { text: i18n.t('DUTYASSIGN_ROSTER_SETTING_SUBCATEGORY_TITLE'), value: 'subCategory' },
    { text: i18n.t('DUTYASSIGN_ROSTER_SETTING_CORPID_TITLE'), value: 'ccCorpId' },
    { text: i18n.t('DUTYASSIGN_ROSTER_SETTING_LAST_UPDATE_TITLE'), value: 'updatedAt' },
  ];
  const aligns = ['left', 'left'];
  const props = {
    tableHeads,
    aligns,
    allData,
    editClick,
    deleteClick,
    deleteDisabledFunc,
  };
  return <Base {...props} />;
};

export { WardTable, RoleTable, UserTable, RoleEditTable, CategoryEditTable };
